import type { CpvCode } from '../api/cpvCodes'
import type { Locale } from '../i18n'

/**
 * The description to show for a CPV code in the given UI language. Croatian
 * falls back to the English label when no (non-blank) Croatian description is
 * stored, so the result is never empty. Croatian descriptions that happen to
 * equal the English ones (e.g. "Tuna", "Lager") are normal, not a gap.
 */
export function cpvLabel(entry: Pick<CpvCode, 'label' | 'labelHr'>, locale: Locale): string {
  if (locale === 'hr') {
    const hr = entry.labelHr?.trim()
    if (hr) return hr
  }
  return entry.label
}
